import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, InputStateToken } from "@voltmoney/schema";
import { customEditPortfolio, portfolioListDatastoreBuilder, } from "../portfolio/utils";
import SharedPropsService from "../../../SharedPropsService";
import { getDesiredValue } from "../portfolio_readonly/actions";
import { addCommasToNumber } from "../../../configs/utils";
let amount = 0;
export const ModifyAmountAction = async (action, _datastore, { setDatastore, goBack }) => {
    if (amount <= 100 || Number.isNaN(amount)) {
        await setDatastore(ROUTE.MODIFY_PLEDGED_AMOUNT, "continue", {
            type: ButtonTypeTokens.LargeOutline
        });
        await setDatastore(ROUTE.MODIFY_PLEDGED_AMOUNT, "input", {
            state: InputStateToken.ERROR,
            caption: { error: "Please enter an amount greater than Rs. 100" }
        });
    }
    else {
        await setDatastore(ROUTE.MODIFY_PLEDGED_AMOUNT, "continue", {
            type: ButtonTypeTokens.LargeFilled
        });
        await setDatastore(ROUTE.MODIFY_PLEDGED_AMOUNT, "input", {
            state: InputStateToken.DEFAULT,
            caption: { error: "" }
        });
        await customEditPortfolio(action.payload.index, amount, action.payload.stepResponseObject);
        const props = await portfolioListDatastoreBuilder(action?.payload?.stepResponseObject, action?.payload?.portfolioSearchKeyword);
        await setDatastore(ROUTE.PORTFOLIO, "listItem", {
            ...props.listItem,
        });
        await setDatastore(ROUTE.PORTFOLIO, "totalItem", {
            ...props.totalItem,
        });
        const portValue = getDesiredValue(action?.payload?.stepResponseObject?.availableCAS, action?.payload?.stepResponseObject?.isinNAVMap);
        await SharedPropsService.setDesiredPortfolio(portValue);
        await setDatastore(ROUTE.PORTFOLIO, "subTitleText", {
            label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(action?.payload?.stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
        });
        await setDatastore(ROUTE.SET_CREDIT_LIMIT, "bottomSheetText2", {
            label: `₹${addCommasToNumber(portValue)} out of ₹${addCommasToNumber(parseInt(action?.payload?.stepResponseObject["totalPortfolioAmount"].toString()))} are selected for pledging.`,
        });
        await goBack();
    }
};
export const EditAmountAction = async (action, _datastore, { setDatastore }) => {
    amount = parseFloat(action.payload.value);
    setDatastore(ROUTE.MODIFY_PLEDGED_AMOUNT, "continue", {
        type: ButtonTypeTokens.LargeFilled
    });
    setDatastore(ROUTE.MODIFY_PLEDGED_AMOUNT, "input", {
        state: InputStateToken.DEFAULT,
        caption: { error: "" }
    });
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
